















































































































































import Icon from '@/packages/ae-icon';
import Form from '@/packages/d-form';
import VNodes from '@/packages/d-select/demo/demo1/v-nodes';
import Vue from 'vue';
import Component from 'vue-class-component';
import DSelect from '../../index';

Vue.use(Form);
Vue.use(Icon);
Vue.use(DSelect);
@Component({
  name: 'Demo1',
  components: {VNodes}
})
export default class Demo1 extends Vue {

  public customRenderOptions = [{
    label: '选项1',
    value: 1
  }];
  public open = false;
  public options = [{
    label: '选项1', value: 1
  }, {
    label: '选项2', value: 2, disabled: true
  }, {
    label: '选项3', value: 3
  }];

  public options2 = [{
    name: '自定义选项1', id: 1
  }, {
    name: '自定义选项2', id: 2
  }];
  public options3 = [];
  public options4 = [];

  public options5 = [{id: 1, name: 'a', description: 'b'}, {
    id: 2, name: 'c', description: 'd'
  }];
  public value1 = null;
  public value2 = null;
  public value3 = null;
  public value4 = 2;
  public value5 = null;
  public value6 = null;
  public value7 = [];

  public value8 = null;

  public created() {
    const options = [];
    for (let i = 0; i < 400; i++) {
      options.push({
        label: '选项' + (i + 1), value: i + 1
      });
    }
    this.options4 = options;
  }

  public addOption() {
    this.customRenderOptions.push({
      value: this.customRenderOptions.length + 1,
      label: '选项' + (this.customRenderOptions.length + 1)
    });
    const select = this.$refs.customDropdown;
    if (select) {
      (select as any).close();
    }
  }

  public createOptions(count: number, freeze: boolean = false) {
    const options = [];
    for (let i = 0; i < count; i++) {
      options.push({
        label: '选项' + (i + 1), value: i + 1
      });
    }
    if (freeze) {
      return options.map(it => Object.freeze(it));
    } else {
      return options;
    }
  }

  public filter(input, option) {
    return option.name.includes(input) || option.description.includes(input);
  }

  public filter2(input, option) {
    console.log(input);
    console.log(option);
    return true;
  }

  public getLabel(option) {
    return option.name + '(' + option.id + ')';
  }

  public loadOptions() {
    const options = [];
    for (let i = 0; i < 300; i++) {
      options.push({
        label: '选项' + (i + 1), value: i + 1
      });
    }
    this.options3 = options;
  }

  public valueChanged() {
  }
}
